import React from 'react'
import { usePage } from '@inertiajs/react'
import { RxDashboard } from 'react-icons/rx'
import { HistoryOutlined, MailOutlined, TagsOutlined } from '@ant-design/icons'

import { Icon } from '@/components/icons'
import FlashMessages from '@/components/FlashMessages'

import Header from './Header'
import Sidebar from './Sidebar'

interface AdminLayoutProps {
  children: React.ReactNode;
  className?: string;
}

interface MenuItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  path?: string;
}

interface SharedProps {
  user?: {
    id: number
    email: string
    name?: string
    role: string
  }
}

const menuItems: MenuItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: <RxDashboard size={16} />,
    path: '/admin',
  },
  {
    key: 'event-management',
    label: 'Event Management',
    icon: <Icon name="eventManagement" size={16} />,
    path: '/admin/events',
  },
  {
    key: 'email-activity',
    label: 'Email Activity',
    icon: <MailOutlined />,
    path: '/admin/email_activity',
  },
  // {
  //   key: 'event-reports',
  //   label: 'Event Reports',
  //   icon: <Icon name="eventReport" size={16} />,
  //   path: '/admin/event_reports',
  // },
  {
    key: 'event-owners',
    label: 'Event Owners',
    icon: <Icon name="eventOwner" size={16} />,
    path: '/admin/event_owners',
  },
  {
    key: 'event-categories',
    label: 'Event Categories',
    icon: <TagsOutlined />,
    path: '/admin/categories',
  },
  {
    key: 'activity-logs',
    label: 'Activity Logs',
    icon: <HistoryOutlined />,
    path: '/admin/activity_logs',
  },
]

export default function AdminLayout({ children, className = '' }: AdminLayoutProps) {
  const { props } = usePage<SharedProps>()
  const currentUser = props.user

  return (
    <div className={`min-h-screen bg-gray-50 ${className}`}>
      <FlashMessages />

      {/* Header - Fixed at top */}
      <Header
        loggedInUser={
          currentUser
            ? {
                name: currentUser.name || currentUser.email,
                role: 'Admin',
                email: currentUser.email,
              }
            : undefined
        }
      />

      {/* Sidebar - Fixed at left */}
      <Sidebar menuItems={menuItems} />

      {/* Main Content Area */}
      <main
        className="transition-all duration-300 ease-in-out"
        style={{
          marginLeft: '256px', // Width of sidebar (w-64 = 256px)
          // paddingTop: "64px", // Height of header
        }}
      >
        <div>{children}</div>
      </main>
    </div>
  )
}
